import TariffPlans from './TariffPlans';

export default TariffPlans;
